import { authFetch } from './api.service';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

export interface PresentationOption {
  id: number;
  name: string;
  description?: string;
  isActive: boolean;
  value: string;
  label: string;
}

interface PresentationsResponse {
  success: boolean;
  data: PresentationOption[];
  meta: {
    total: number;
    timestamp: string;
  };
}

// Obtener todas las presentaciones disponibles
export const fetchPresentations = async (): Promise<PresentationOption[]> => {
  try {
    const response = await authFetch(`${API_BASE_URL}/presentations`);

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const result: PresentationsResponse = await response.json();
    return result.success ? result.data : [];
  } catch (error) {
    console.error('Error fetching presentations:', error);
    throw error;
  }
};

export const presentationsService = {
  fetchPresentations
};